import styled from 'styled-components'
import { space, layout, color, SpaceProps, LayoutProps, flexbox, FlexboxProps, display, DisplayProps, backgroundColor, border, borderRadius, BorderProps, BorderRadiusProps, position, PositionProps, BackgroundColorProps, compose, grid, GridProps, zIndex, ZIndexProps, textAlign, TextAlignProps } from 'styled-system'

export interface BoxProps extends SpaceProps, LayoutProps, FlexboxProps, DisplayProps, BackgroundColorProps, BorderProps, BorderRadiusProps, PositionProps, GridProps, ZIndexProps, TextAlignProps {}

const Box = styled.div<BoxProps>(
  compose(
    space,
    layout,
    color,
    flexbox,
    display,
    backgroundColor,
    border,
    borderRadius,
    position,
    grid,
    zIndex,
    textAlign
  )
)

export default Box